module.exports = __webpack_public_path__ + "media/images/contact_us_24hour-ded74f42.png";